import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6hun3vtu6: FaireProductEntity = {
  token: "p_g6hun3vtu6",
  type: "product",
  name: "Flatiron - 5lbs - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/c346432dfc982ccb1add7dbb6a44ecfdde93919daac413b461f54f55e370970e.jpeg",
  galleryImageUrls: [],
  priceDollars: 72.8,
  description: "We created this blend specially for our New York customers and liked it so much we now serve it at our Vanderbilt and Long Island City stores. Sweet, velvety and rich with chocolate, this balanced espresso shines in milk-based drinks.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Sources Carmo Coffees and ASOBOMBO\n• Tasting Notes Dark Chocolate, Praline and Dates\n• Elevation 1,100 - 1,900 meters\n• Region Minas Gerais and Antioquia\n• Process Dry and Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\n• Yes\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 126.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:56.691Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
